export default "__VITE_ASSET__cTvC7xVr__"